// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file entrypoints/v1/entrypoints.proto (package entrypoints.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssetType, AssetTypeJson, VersionIncrement, VersionIncrementJson } from "../../asset/v1/asset_pb";
import { file_asset_v1_asset } from "../../asset/v1/asset_pb";
import type { BatchType, BatchTypeJson, Code, CodeDesign, CodeDesignJson, CodeJson, Destination, DestinationJson, Identity, IdentityJson } from "../../codes/v3/codes_pb";
import { file_codes_v3_codes } from "../../codes/v3/codes_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { FieldMask, FieldMaskJson, StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ShortUrl, ShortUrlJson } from "../../shorturls/v1/shorturls_pb";
import { file_shorturls_v1_shorturls } from "../../shorturls/v1/shorturls_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file entrypoints/v1/entrypoints.proto.
 */
export const file_entrypoints_v1_entrypoints: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_asset_v1_asset, file_codes_v3_codes, file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp, file_shorturls_v1_shorturls],
	);

/**
 * @generated from message entrypoints.v1.EntrypointBatch
 */
export type EntrypointBatch = Message<"entrypoints.v1.EntrypointBatch"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 20;
	 */
	version: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: optional string brand_kit_id = 7;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: optional string domain_id = 8;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: optional string domain = 9;
	 */
	domain?: string | undefined;

	/**
	 * @generated from field: string state = 10;
	 */
	state: string;

	/**
	 * @generated from field: string folder_path = 11;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 12;
	 */
	tags: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 13;
	 */
	baseDestination?: Destination | undefined;

	/**
	 * @generated from field: string link_suffix = 14;
	 */
	linkSuffix: string;

	/**
	 * code design that children inherit
	 *
	 * @generated from field: codes.v3.CodeDesign base_design = 15;
	 */
	baseDesign?: CodeDesign | undefined;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 16;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: string metadata_schema = 17;
	 */
	metadataSchema: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 18;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 19;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: codes.v3.BatchType batch_type = 21;
	 */
	batchType: BatchType;
};

/**
 * @generated from message entrypoints.v1.EntrypointBatch
 */
export type EntrypointBatchJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 20;
	 */
	version?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: optional string brand_kit_id = 7;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: optional string domain_id = 8;
	 */
	domainId?: string;

	/**
	 * @generated from field: optional string domain = 9;
	 */
	domain?: string;

	/**
	 * @generated from field: string state = 10;
	 */
	state?: string;

	/**
	 * @generated from field: string folder_path = 11;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 12;
	 */
	tags?: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 13;
	 */
	baseDestination?: DestinationJson;

	/**
	 * @generated from field: string link_suffix = 14;
	 */
	linkSuffix?: string;

	/**
	 * code design that children inherit
	 *
	 * @generated from field: codes.v3.CodeDesign base_design = 15;
	 */
	baseDesign?: CodeDesignJson;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 16;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: string metadata_schema = 17;
	 */
	metadataSchema?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 18;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 19;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: codes.v3.BatchType batch_type = 21;
	 */
	batchType?: BatchTypeJson;
};

/**
 * Describes the message entrypoints.v1.EntrypointBatch.
 * Use `create(EntrypointBatchSchema)` to create a new message.
 */
export const EntrypointBatchSchema: GenMessage<EntrypointBatch, { jsonType: EntrypointBatchJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 0);

/**
 * @generated from message entrypoints.v1.EntrypointMetadata
 */
export type EntrypointMetadata = Message<"entrypoints.v1.EntrypointMetadata"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 3;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: asset.v1.AssetType type = 4;
	 */
	type: AssetType;

	/**
	 * @generated from field: codes.v3.Identity identity = 5;
	 */
	identity?: Identity | undefined;
};

/**
 * @generated from message entrypoints.v1.EntrypointMetadata
 */
export type EntrypointMetadataJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 3;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: asset.v1.AssetType type = 4;
	 */
	type?: AssetTypeJson;

	/**
	 * @generated from field: codes.v3.Identity identity = 5;
	 */
	identity?: IdentityJson;
};

/**
 * Describes the message entrypoints.v1.EntrypointMetadata.
 * Use `create(EntrypointMetadataSchema)` to create a new message.
 */
export const EntrypointMetadataSchema: GenMessage<EntrypointMetadata, { jsonType: EntrypointMetadataJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 1);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchRequest
 */
export type CreateEntrypointBatchRequest = Message<"entrypoints.v1.CreateEntrypointBatchRequest"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatch | undefined;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchRequest
 */
export type CreateEntrypointBatchRequestJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatchJson;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchRequest.
 * Use `create(CreateEntrypointBatchRequestSchema)` to create a new message.
 */
export const CreateEntrypointBatchRequestSchema: GenMessage<CreateEntrypointBatchRequest, { jsonType: CreateEntrypointBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 2);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchResponse
 */
export type CreateEntrypointBatchResponse = Message<"entrypoints.v1.CreateEntrypointBatchResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatch | undefined;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchResponse
 */
export type CreateEntrypointBatchResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatchJson;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchResponse.
 * Use `create(CreateEntrypointBatchResponseSchema)` to create a new message.
 */
export const CreateEntrypointBatchResponseSchema: GenMessage<CreateEntrypointBatchResponse, { jsonType: CreateEntrypointBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 3);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchVersionRequest
 */
export type CreateEntrypointBatchVersionRequest = Message<"entrypoints.v1.CreateEntrypointBatchVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 2;
	 */
	increment: VersionIncrement;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion: string;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchVersionRequest
 */
export type CreateEntrypointBatchVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 2;
	 */
	increment?: VersionIncrementJson;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion?: string;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchVersionRequest.
 * Use `create(CreateEntrypointBatchVersionRequestSchema)` to create a new message.
 */
export const CreateEntrypointBatchVersionRequestSchema: GenMessage<CreateEntrypointBatchVersionRequest, { jsonType: CreateEntrypointBatchVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 4);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchVersionResponse
 */
export type CreateEntrypointBatchVersionResponse = Message<"entrypoints.v1.CreateEntrypointBatchVersionResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatch | undefined;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchVersionResponse
 */
export type CreateEntrypointBatchVersionResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatchJson;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchVersionResponse.
 * Use `create(CreateEntrypointBatchVersionResponseSchema)` to create a new message.
 */
export const CreateEntrypointBatchVersionResponseSchema: GenMessage<CreateEntrypointBatchVersionResponse, { jsonType: CreateEntrypointBatchVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 5);

/**
 * @generated from message entrypoints.v1.PublishEntrypointBatchVersionRequest
 */
export type PublishEntrypointBatchVersionRequest = Message<"entrypoints.v1.PublishEntrypointBatchVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message entrypoints.v1.PublishEntrypointBatchVersionRequest
 */
export type PublishEntrypointBatchVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message entrypoints.v1.PublishEntrypointBatchVersionRequest.
 * Use `create(PublishEntrypointBatchVersionRequestSchema)` to create a new message.
 */
export const PublishEntrypointBatchVersionRequestSchema: GenMessage<PublishEntrypointBatchVersionRequest, { jsonType: PublishEntrypointBatchVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 6);

/**
 * @generated from message entrypoints.v1.PublishEntrypointBatchVersionResponse
 */
export type PublishEntrypointBatchVersionResponse = Message<"entrypoints.v1.PublishEntrypointBatchVersionResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatch | undefined;
};

/**
 * @generated from message entrypoints.v1.PublishEntrypointBatchVersionResponse
 */
export type PublishEntrypointBatchVersionResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatchJson;
};

/**
 * Describes the message entrypoints.v1.PublishEntrypointBatchVersionResponse.
 * Use `create(PublishEntrypointBatchVersionResponseSchema)` to create a new message.
 */
export const PublishEntrypointBatchVersionResponseSchema: GenMessage<PublishEntrypointBatchVersionResponse, { jsonType: PublishEntrypointBatchVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 7);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchFromTemplateRequest
 */
export type CreateEntrypointBatchFromTemplateRequest = Message<"entrypoints.v1.CreateEntrypointBatchFromTemplateRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string template_id = 3;
	 */
	templateId: string;

	/**
	 * @generated from field: string template_version = 13;
	 */
	templateVersion: string;

	/**
	 * @generated from field: optional string brand_kit_id = 4;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: optional string domain_id = 5;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: string folder_path = 6;
	 */
	folderPath: string;

	/**
	 * @generated from field: string name = 7;
	 */
	name: string;

	/**
	 * @generated from field: string description = 8;
	 */
	description: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 10;
	 */
	baseDestination?: Destination | undefined;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 11;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: string metadata_schema = 12;
	 */
	metadataSchema: string;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchFromTemplateRequest
 */
export type CreateEntrypointBatchFromTemplateRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string template_id = 3;
	 */
	templateId?: string;

	/**
	 * @generated from field: string template_version = 13;
	 */
	templateVersion?: string;

	/**
	 * @generated from field: optional string brand_kit_id = 4;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: optional string domain_id = 5;
	 */
	domainId?: string;

	/**
	 * @generated from field: string folder_path = 6;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string name = 7;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 8;
	 */
	description?: string;

	/**
	 * @generated from field: repeated string tags = 9;
	 */
	tags?: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 10;
	 */
	baseDestination?: DestinationJson;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 11;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: string metadata_schema = 12;
	 */
	metadataSchema?: string;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchFromTemplateRequest.
 * Use `create(CreateEntrypointBatchFromTemplateRequestSchema)` to create a new message.
 */
export const CreateEntrypointBatchFromTemplateRequestSchema: GenMessage<CreateEntrypointBatchFromTemplateRequest, { jsonType: CreateEntrypointBatchFromTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 8);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchFromTemplateResponse
 */
export type CreateEntrypointBatchFromTemplateResponse = Message<"entrypoints.v1.CreateEntrypointBatchFromTemplateResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatch | undefined;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchFromTemplateResponse
 */
export type CreateEntrypointBatchFromTemplateResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatchJson;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchFromTemplateResponse.
 * Use `create(CreateEntrypointBatchFromTemplateResponseSchema)` to create a new message.
 */
export const CreateEntrypointBatchFromTemplateResponseSchema: GenMessage<CreateEntrypointBatchFromTemplateResponse, { jsonType: CreateEntrypointBatchFromTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 9);

/**
 * @generated from message entrypoints.v1.ListEntrypointBatchesRequest
 */
export type ListEntrypointBatchesRequest = Message<"entrypoints.v1.ListEntrypointBatchesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * @generated from field: repeated string states = 8;
	 */
	states: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message entrypoints.v1.ListEntrypointBatchesRequest
 */
export type ListEntrypointBatchesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * @generated from field: repeated string states = 8;
	 */
	states?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message entrypoints.v1.ListEntrypointBatchesRequest.
 * Use `create(ListEntrypointBatchesRequestSchema)` to create a new message.
 */
export const ListEntrypointBatchesRequestSchema: GenMessage<ListEntrypointBatchesRequest, { jsonType: ListEntrypointBatchesRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 10);

/**
 * @generated from message entrypoints.v1.ListEntrypointBatchesResponse
 */
export type ListEntrypointBatchesResponse = Message<"entrypoints.v1.ListEntrypointBatchesResponse"> & {
	/**
	 * @generated from field: repeated entrypoints.v1.EntrypointBatch batches = 1;
	 */
	batches: EntrypointBatch[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message entrypoints.v1.ListEntrypointBatchesResponse
 */
export type ListEntrypointBatchesResponseJson = {
	/**
	 * @generated from field: repeated entrypoints.v1.EntrypointBatch batches = 1;
	 */
	batches?: EntrypointBatchJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message entrypoints.v1.ListEntrypointBatchesResponse.
 * Use `create(ListEntrypointBatchesResponseSchema)` to create a new message.
 */
export const ListEntrypointBatchesResponseSchema: GenMessage<ListEntrypointBatchesResponse, { jsonType: ListEntrypointBatchesResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 11);

/**
 * @generated from message entrypoints.v1.GetEntrypointBatchRequest
 */
export type GetEntrypointBatchRequest = Message<"entrypoints.v1.GetEntrypointBatchRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message entrypoints.v1.GetEntrypointBatchRequest
 */
export type GetEntrypointBatchRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message entrypoints.v1.GetEntrypointBatchRequest.
 * Use `create(GetEntrypointBatchRequestSchema)` to create a new message.
 */
export const GetEntrypointBatchRequestSchema: GenMessage<GetEntrypointBatchRequest, { jsonType: GetEntrypointBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 12);

/**
 * @generated from message entrypoints.v1.GetEntrypointBatchResponse
 */
export type GetEntrypointBatchResponse = Message<"entrypoints.v1.GetEntrypointBatchResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatch | undefined;
};

/**
 * @generated from message entrypoints.v1.GetEntrypointBatchResponse
 */
export type GetEntrypointBatchResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatchJson;
};

/**
 * Describes the message entrypoints.v1.GetEntrypointBatchResponse.
 * Use `create(GetEntrypointBatchResponseSchema)` to create a new message.
 */
export const GetEntrypointBatchResponseSchema: GenMessage<GetEntrypointBatchResponse, { jsonType: GetEntrypointBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 13);

/**
 * @generated from message entrypoints.v1.GetEntrypointRequest
 */
export type GetEntrypointRequest = Message<"entrypoints.v1.GetEntrypointRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: bool omit_default_metadata = 2;
	 */
	omitDefaultMetadata: boolean;
};

/**
 * @generated from message entrypoints.v1.GetEntrypointRequest
 */
export type GetEntrypointRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: bool omit_default_metadata = 2;
	 */
	omitDefaultMetadata?: boolean;
};

/**
 * Describes the message entrypoints.v1.GetEntrypointRequest.
 * Use `create(GetEntrypointRequestSchema)` to create a new message.
 */
export const GetEntrypointRequestSchema: GenMessage<GetEntrypointRequest, { jsonType: GetEntrypointRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 14);

/**
 * @generated from message entrypoints.v1.GetEntrypointResponse
 */
export type GetEntrypointResponse = Message<"entrypoints.v1.GetEntrypointResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.Entrypoint entrypoint = 2;
	 */
	entrypoint?: Entrypoint | undefined;
};

/**
 * @generated from message entrypoints.v1.GetEntrypointResponse
 */
export type GetEntrypointResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.Entrypoint entrypoint = 2;
	 */
	entrypoint?: EntrypointJson;
};

/**
 * Describes the message entrypoints.v1.GetEntrypointResponse.
 * Use `create(GetEntrypointResponseSchema)` to create a new message.
 */
export const GetEntrypointResponseSchema: GenMessage<GetEntrypointResponse, { jsonType: GetEntrypointResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 15);

/**
 * @generated from message entrypoints.v1.GetEntrypointMetadataRequest
 */
export type GetEntrypointMetadataRequest = Message<"entrypoints.v1.GetEntrypointMetadataRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string batch_id = 2;
	 */
	batchId: string;
};

/**
 * @generated from message entrypoints.v1.GetEntrypointMetadataRequest
 */
export type GetEntrypointMetadataRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string batch_id = 2;
	 */
	batchId?: string;
};

/**
 * Describes the message entrypoints.v1.GetEntrypointMetadataRequest.
 * Use `create(GetEntrypointMetadataRequestSchema)` to create a new message.
 */
export const GetEntrypointMetadataRequestSchema: GenMessage<GetEntrypointMetadataRequest, { jsonType: GetEntrypointMetadataRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 16);

/**
 * @generated from message entrypoints.v1.GetEntrypointMetadataResponse
 */
export type GetEntrypointMetadataResponse = Message<"entrypoints.v1.GetEntrypointMetadataResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointMetadata metadata = 1;
	 */
	metadata?: EntrypointMetadata | undefined;
};

/**
 * @generated from message entrypoints.v1.GetEntrypointMetadataResponse
 */
export type GetEntrypointMetadataResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointMetadata metadata = 1;
	 */
	metadata?: EntrypointMetadataJson;
};

/**
 * Describes the message entrypoints.v1.GetEntrypointMetadataResponse.
 * Use `create(GetEntrypointMetadataResponseSchema)` to create a new message.
 */
export const GetEntrypointMetadataResponseSchema: GenMessage<GetEntrypointMetadataResponse, { jsonType: GetEntrypointMetadataResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 17);

/**
 * @generated from message entrypoints.v1.CountEntrypointsRequest
 */
export type CountEntrypointsRequest = Message<"entrypoints.v1.CountEntrypointsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix: string;

	/**
	 * @generated from field: optional string exact_name = 6;
	 */
	exactName?: string | undefined;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * @generated from field: string batch_id = 8;
	 */
	batchId: string;

	/**
	 * @generated from field: repeated string states = 9;
	 */
	states: string[];

	/**
	 * @generated from field: repeated asset.v1.AssetType asset_types = 10;
	 */
	assetTypes: AssetType[];
};

/**
 * @generated from message entrypoints.v1.CountEntrypointsRequest
 */
export type CountEntrypointsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: optional string exact_name = 6;
	 */
	exactName?: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * @generated from field: string batch_id = 8;
	 */
	batchId?: string;

	/**
	 * @generated from field: repeated string states = 9;
	 */
	states?: string[];

	/**
	 * @generated from field: repeated asset.v1.AssetType asset_types = 10;
	 */
	assetTypes?: AssetTypeJson[];
};

/**
 * Describes the message entrypoints.v1.CountEntrypointsRequest.
 * Use `create(CountEntrypointsRequestSchema)` to create a new message.
 */
export const CountEntrypointsRequestSchema: GenMessage<CountEntrypointsRequest, { jsonType: CountEntrypointsRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 18);

/**
 * @generated from message entrypoints.v1.CountEntrypointsResponse
 */
export type CountEntrypointsResponse = Message<"entrypoints.v1.CountEntrypointsResponse"> & {
	/**
	 * @generated from field: int32 count = 1;
	 */
	count: number;
};

/**
 * @generated from message entrypoints.v1.CountEntrypointsResponse
 */
export type CountEntrypointsResponseJson = {
	/**
	 * @generated from field: int32 count = 1;
	 */
	count?: number;
};

/**
 * Describes the message entrypoints.v1.CountEntrypointsResponse.
 * Use `create(CountEntrypointsResponseSchema)` to create a new message.
 */
export const CountEntrypointsResponseSchema: GenMessage<CountEntrypointsResponse, { jsonType: CountEntrypointsResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 19);

/**
 * @generated from message entrypoints.v1.Entrypoint
 */
export type Entrypoint = Message<"entrypoints.v1.Entrypoint"> & {
	/**
	 * @generated from oneof entrypoints.v1.Entrypoint.entrypoint
	 */
	entrypoint:
		| {
				/**
				 * @generated from field: codes.v3.Code code = 1;
				 */
				value: Code;
				case: "code";
		  }
		| {
				/**
				 * @generated from field: shorturls.v1.ShortUrl short_url = 2;
				 */
				value: ShortUrl;
				case: "shortUrl";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message entrypoints.v1.Entrypoint
 */
export type EntrypointJson = {
	/**
	 * @generated from field: codes.v3.Code code = 1;
	 */
	code?: CodeJson;

	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 2;
	 */
	shortUrl?: ShortUrlJson;
};

/**
 * Describes the message entrypoints.v1.Entrypoint.
 * Use `create(EntrypointSchema)` to create a new message.
 */
export const EntrypointSchema: GenMessage<Entrypoint, { jsonType: EntrypointJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 20);

/**
 * @generated from message entrypoints.v1.UpdateEntrypointBatchRequest
 */
export type UpdateEntrypointBatchRequest = Message<"entrypoints.v1.UpdateEntrypointBatchRequest"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatch | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message entrypoints.v1.UpdateEntrypointBatchRequest
 */
export type UpdateEntrypointBatchRequestJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatchJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message entrypoints.v1.UpdateEntrypointBatchRequest.
 * Use `create(UpdateEntrypointBatchRequestSchema)` to create a new message.
 */
export const UpdateEntrypointBatchRequestSchema: GenMessage<UpdateEntrypointBatchRequest, { jsonType: UpdateEntrypointBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 21);

/**
 * @generated from message entrypoints.v1.UpdateEntrypointBatchResponse
 */
export type UpdateEntrypointBatchResponse = Message<"entrypoints.v1.UpdateEntrypointBatchResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatch | undefined;
};

/**
 * @generated from message entrypoints.v1.UpdateEntrypointBatchResponse
 */
export type UpdateEntrypointBatchResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatch batch = 1;
	 */
	batch?: EntrypointBatchJson;
};

/**
 * Describes the message entrypoints.v1.UpdateEntrypointBatchResponse.
 * Use `create(UpdateEntrypointBatchResponseSchema)` to create a new message.
 */
export const UpdateEntrypointBatchResponseSchema: GenMessage<UpdateEntrypointBatchResponse, { jsonType: UpdateEntrypointBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 22);

/**
 * @generated from message entrypoints.v1.DeleteEntrypointBatchRequest
 */
export type DeleteEntrypointBatchRequest = Message<"entrypoints.v1.DeleteEntrypointBatchRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message entrypoints.v1.DeleteEntrypointBatchRequest
 */
export type DeleteEntrypointBatchRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message entrypoints.v1.DeleteEntrypointBatchRequest.
 * Use `create(DeleteEntrypointBatchRequestSchema)` to create a new message.
 */
export const DeleteEntrypointBatchRequestSchema: GenMessage<DeleteEntrypointBatchRequest, { jsonType: DeleteEntrypointBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 23);

/**
 * @generated from message entrypoints.v1.DeleteEntrypointBatchResponse
 */
export type DeleteEntrypointBatchResponse = Message<"entrypoints.v1.DeleteEntrypointBatchResponse"> & {};

/**
 * @generated from message entrypoints.v1.DeleteEntrypointBatchResponse
 */
export type DeleteEntrypointBatchResponseJson = {};

/**
 * Describes the message entrypoints.v1.DeleteEntrypointBatchResponse.
 * Use `create(DeleteEntrypointBatchResponseSchema)` to create a new message.
 */
export const DeleteEntrypointBatchResponseSchema: GenMessage<DeleteEntrypointBatchResponse, { jsonType: DeleteEntrypointBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 24);

/**
 * @generated from message entrypoints.v1.EntrypointBatchTemplate
 */
export type EntrypointBatchTemplate = Message<"entrypoints.v1.EntrypointBatchTemplate"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: optional string brand_kit_id = 8;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: optional string domain_id = 9;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: string state = 10;
	 */
	state: string;

	/**
	 * @generated from field: string visibility = 11;
	 */
	visibility: string;

	/**
	 * @generated from field: string folder_path = 12;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 13;
	 */
	tags: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 14;
	 */
	baseDestination?: Destination | undefined;

	/**
	 * @generated from field: string link_suffix = 15;
	 */
	linkSuffix: string;

	/**
	 * code design that children inherit
	 *
	 * @generated from field: codes.v3.CodeDesign base_design = 16;
	 */
	baseDesign?: CodeDesign | undefined;

	/**
	 * @generated from field: string metadata_schema = 17;
	 */
	metadataSchema: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 18;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 19;
	 */
	updatedAt?: Timestamp | undefined;

	/**
	 * @generated from field: codes.v3.BatchType batch_type = 20;
	 */
	batchType: BatchType;
};

/**
 * @generated from message entrypoints.v1.EntrypointBatchTemplate
 */
export type EntrypointBatchTemplateJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 4;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 6;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: optional string brand_kit_id = 8;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: optional string domain_id = 9;
	 */
	domainId?: string;

	/**
	 * @generated from field: string state = 10;
	 */
	state?: string;

	/**
	 * @generated from field: string visibility = 11;
	 */
	visibility?: string;

	/**
	 * @generated from field: string folder_path = 12;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 13;
	 */
	tags?: string[];

	/**
	 * @generated from field: codes.v3.Destination base_destination = 14;
	 */
	baseDestination?: DestinationJson;

	/**
	 * @generated from field: string link_suffix = 15;
	 */
	linkSuffix?: string;

	/**
	 * code design that children inherit
	 *
	 * @generated from field: codes.v3.CodeDesign base_design = 16;
	 */
	baseDesign?: CodeDesignJson;

	/**
	 * @generated from field: string metadata_schema = 17;
	 */
	metadataSchema?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 18;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 19;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: codes.v3.BatchType batch_type = 20;
	 */
	batchType?: BatchTypeJson;
};

/**
 * Describes the message entrypoints.v1.EntrypointBatchTemplate.
 * Use `create(EntrypointBatchTemplateSchema)` to create a new message.
 */
export const EntrypointBatchTemplateSchema: GenMessage<EntrypointBatchTemplate, { jsonType: EntrypointBatchTemplateJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 25);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchTemplateRequest
 */
export type CreateEntrypointBatchTemplateRequest = Message<"entrypoints.v1.CreateEntrypointBatchTemplateRequest"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplate | undefined;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchTemplateRequest
 */
export type CreateEntrypointBatchTemplateRequestJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplateJson;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchTemplateRequest.
 * Use `create(CreateEntrypointBatchTemplateRequestSchema)` to create a new message.
 */
export const CreateEntrypointBatchTemplateRequestSchema: GenMessage<CreateEntrypointBatchTemplateRequest, { jsonType: CreateEntrypointBatchTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 26);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchTemplateResponse
 */
export type CreateEntrypointBatchTemplateResponse = Message<"entrypoints.v1.CreateEntrypointBatchTemplateResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplate | undefined;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchTemplateResponse
 */
export type CreateEntrypointBatchTemplateResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplateJson;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchTemplateResponse.
 * Use `create(CreateEntrypointBatchTemplateResponseSchema)` to create a new message.
 */
export const CreateEntrypointBatchTemplateResponseSchema: GenMessage<CreateEntrypointBatchTemplateResponse, { jsonType: CreateEntrypointBatchTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 27);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchTemplateVersionRequest
 */
export type CreateEntrypointBatchTemplateVersionRequest = Message<"entrypoints.v1.CreateEntrypointBatchTemplateVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment: VersionIncrement;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion: string;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchTemplateVersionRequest
 */
export type CreateEntrypointBatchTemplateVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2 [deprecated = true];
	 * @deprecated
	 */
	version?: string;

	/**
	 * @generated from field: asset.v1.VersionIncrement increment = 4;
	 */
	increment?: VersionIncrementJson;

	/**
	 * @generated from field: string base_version = 3;
	 */
	baseVersion?: string;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchTemplateVersionRequest.
 * Use `create(CreateEntrypointBatchTemplateVersionRequestSchema)` to create a new message.
 */
export const CreateEntrypointBatchTemplateVersionRequestSchema: GenMessage<CreateEntrypointBatchTemplateVersionRequest, { jsonType: CreateEntrypointBatchTemplateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 28);

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchTemplateVersionResponse
 */
export type CreateEntrypointBatchTemplateVersionResponse = Message<"entrypoints.v1.CreateEntrypointBatchTemplateVersionResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplate | undefined;
};

/**
 * @generated from message entrypoints.v1.CreateEntrypointBatchTemplateVersionResponse
 */
export type CreateEntrypointBatchTemplateVersionResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplateJson;
};

/**
 * Describes the message entrypoints.v1.CreateEntrypointBatchTemplateVersionResponse.
 * Use `create(CreateEntrypointBatchTemplateVersionResponseSchema)` to create a new message.
 */
export const CreateEntrypointBatchTemplateVersionResponseSchema: GenMessage<CreateEntrypointBatchTemplateVersionResponse, { jsonType: CreateEntrypointBatchTemplateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 29);

/**
 * @generated from message entrypoints.v1.PublishEntrypointBatchTemplateVersionRequest
 */
export type PublishEntrypointBatchTemplateVersionRequest = Message<"entrypoints.v1.PublishEntrypointBatchTemplateVersionRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility: string;
};

/**
 * @generated from message entrypoints.v1.PublishEntrypointBatchTemplateVersionRequest
 */
export type PublishEntrypointBatchTemplateVersionRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;

	/**
	 * @generated from field: string visibility = 3;
	 */
	visibility?: string;
};

/**
 * Describes the message entrypoints.v1.PublishEntrypointBatchTemplateVersionRequest.
 * Use `create(PublishEntrypointBatchTemplateVersionRequestSchema)` to create a new message.
 */
export const PublishEntrypointBatchTemplateVersionRequestSchema: GenMessage<PublishEntrypointBatchTemplateVersionRequest, { jsonType: PublishEntrypointBatchTemplateVersionRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 30);

/**
 * @generated from message entrypoints.v1.PublishEntrypointBatchTemplateVersionResponse
 */
export type PublishEntrypointBatchTemplateVersionResponse = Message<"entrypoints.v1.PublishEntrypointBatchTemplateVersionResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplate | undefined;
};

/**
 * @generated from message entrypoints.v1.PublishEntrypointBatchTemplateVersionResponse
 */
export type PublishEntrypointBatchTemplateVersionResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplateJson;
};

/**
 * Describes the message entrypoints.v1.PublishEntrypointBatchTemplateVersionResponse.
 * Use `create(PublishEntrypointBatchTemplateVersionResponseSchema)` to create a new message.
 */
export const PublishEntrypointBatchTemplateVersionResponseSchema: GenMessage<PublishEntrypointBatchTemplateVersionResponse, { jsonType: PublishEntrypointBatchTemplateVersionResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 31);

/**
 * @generated from message entrypoints.v1.ListEntrypointBatchTemplatesRequest
 */
export type ListEntrypointBatchTemplatesRequest = Message<"entrypoints.v1.ListEntrypointBatchTemplatesRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message entrypoints.v1.ListEntrypointBatchTemplatesRequest
 */
export type ListEntrypointBatchTemplatesRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string creator_id = 5;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 6;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: repeated string tags = 7;
	 */
	tags?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message entrypoints.v1.ListEntrypointBatchTemplatesRequest.
 * Use `create(ListEntrypointBatchTemplatesRequestSchema)` to create a new message.
 */
export const ListEntrypointBatchTemplatesRequestSchema: GenMessage<ListEntrypointBatchTemplatesRequest, { jsonType: ListEntrypointBatchTemplatesRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 32);

/**
 * @generated from message entrypoints.v1.ListEntrypointBatchTemplatesResponse
 */
export type ListEntrypointBatchTemplatesResponse = Message<"entrypoints.v1.ListEntrypointBatchTemplatesResponse"> & {
	/**
	 * @generated from field: repeated entrypoints.v1.EntrypointBatchTemplate templates = 1;
	 */
	templates: EntrypointBatchTemplate[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message entrypoints.v1.ListEntrypointBatchTemplatesResponse
 */
export type ListEntrypointBatchTemplatesResponseJson = {
	/**
	 * @generated from field: repeated entrypoints.v1.EntrypointBatchTemplate templates = 1;
	 */
	templates?: EntrypointBatchTemplateJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message entrypoints.v1.ListEntrypointBatchTemplatesResponse.
 * Use `create(ListEntrypointBatchTemplatesResponseSchema)` to create a new message.
 */
export const ListEntrypointBatchTemplatesResponseSchema: GenMessage<ListEntrypointBatchTemplatesResponse, { jsonType: ListEntrypointBatchTemplatesResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 33);

/**
 * @generated from message entrypoints.v1.GetEntrypointBatchTemplateRequest
 */
export type GetEntrypointBatchTemplateRequest = Message<"entrypoints.v1.GetEntrypointBatchTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message entrypoints.v1.GetEntrypointBatchTemplateRequest
 */
export type GetEntrypointBatchTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message entrypoints.v1.GetEntrypointBatchTemplateRequest.
 * Use `create(GetEntrypointBatchTemplateRequestSchema)` to create a new message.
 */
export const GetEntrypointBatchTemplateRequestSchema: GenMessage<GetEntrypointBatchTemplateRequest, { jsonType: GetEntrypointBatchTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 34);

/**
 * @generated from message entrypoints.v1.GetEntrypointBatchTemplateResponse
 */
export type GetEntrypointBatchTemplateResponse = Message<"entrypoints.v1.GetEntrypointBatchTemplateResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplate | undefined;
};

/**
 * @generated from message entrypoints.v1.GetEntrypointBatchTemplateResponse
 */
export type GetEntrypointBatchTemplateResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplateJson;
};

/**
 * Describes the message entrypoints.v1.GetEntrypointBatchTemplateResponse.
 * Use `create(GetEntrypointBatchTemplateResponseSchema)` to create a new message.
 */
export const GetEntrypointBatchTemplateResponseSchema: GenMessage<GetEntrypointBatchTemplateResponse, { jsonType: GetEntrypointBatchTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 35);

/**
 * @generated from message entrypoints.v1.UpdateEntrypointBatchTemplateRequest
 */
export type UpdateEntrypointBatchTemplateRequest = Message<"entrypoints.v1.UpdateEntrypointBatchTemplateRequest"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplate | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message entrypoints.v1.UpdateEntrypointBatchTemplateRequest
 */
export type UpdateEntrypointBatchTemplateRequestJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplateJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message entrypoints.v1.UpdateEntrypointBatchTemplateRequest.
 * Use `create(UpdateEntrypointBatchTemplateRequestSchema)` to create a new message.
 */
export const UpdateEntrypointBatchTemplateRequestSchema: GenMessage<UpdateEntrypointBatchTemplateRequest, { jsonType: UpdateEntrypointBatchTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 36);

/**
 * @generated from message entrypoints.v1.UpdateEntrypointBatchTemplateResponse
 */
export type UpdateEntrypointBatchTemplateResponse = Message<"entrypoints.v1.UpdateEntrypointBatchTemplateResponse"> & {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplate | undefined;
};

/**
 * @generated from message entrypoints.v1.UpdateEntrypointBatchTemplateResponse
 */
export type UpdateEntrypointBatchTemplateResponseJson = {
	/**
	 * @generated from field: entrypoints.v1.EntrypointBatchTemplate template = 1;
	 */
	template?: EntrypointBatchTemplateJson;
};

/**
 * Describes the message entrypoints.v1.UpdateEntrypointBatchTemplateResponse.
 * Use `create(UpdateEntrypointBatchTemplateResponseSchema)` to create a new message.
 */
export const UpdateEntrypointBatchTemplateResponseSchema: GenMessage<UpdateEntrypointBatchTemplateResponse, { jsonType: UpdateEntrypointBatchTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 37);

/**
 * @generated from message entrypoints.v1.DeleteEntrypointBatchTemplateRequest
 */
export type DeleteEntrypointBatchTemplateRequest = Message<"entrypoints.v1.DeleteEntrypointBatchTemplateRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message entrypoints.v1.DeleteEntrypointBatchTemplateRequest
 */
export type DeleteEntrypointBatchTemplateRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message entrypoints.v1.DeleteEntrypointBatchTemplateRequest.
 * Use `create(DeleteEntrypointBatchTemplateRequestSchema)` to create a new message.
 */
export const DeleteEntrypointBatchTemplateRequestSchema: GenMessage<DeleteEntrypointBatchTemplateRequest, { jsonType: DeleteEntrypointBatchTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 38);

/**
 * @generated from message entrypoints.v1.DeleteEntrypointBatchTemplateResponse
 */
export type DeleteEntrypointBatchTemplateResponse = Message<"entrypoints.v1.DeleteEntrypointBatchTemplateResponse"> & {};

/**
 * @generated from message entrypoints.v1.DeleteEntrypointBatchTemplateResponse
 */
export type DeleteEntrypointBatchTemplateResponseJson = {};

/**
 * Describes the message entrypoints.v1.DeleteEntrypointBatchTemplateResponse.
 * Use `create(DeleteEntrypointBatchTemplateResponseSchema)` to create a new message.
 */
export const DeleteEntrypointBatchTemplateResponseSchema: GenMessage<DeleteEntrypointBatchTemplateResponse, { jsonType: DeleteEntrypointBatchTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 39);

/**
 * @generated from message entrypoints.v1.ListEntrypointsRequest
 */
export type ListEntrypointsRequest = Message<"entrypoints.v1.ListEntrypointsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * @generated from field: repeated asset.v1.AssetType asset_types = 4;
	 */
	assetTypes: AssetType[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message entrypoints.v1.ListEntrypointsRequest
 */
export type ListEntrypointsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * @generated from field: repeated asset.v1.AssetType asset_types = 4;
	 */
	assetTypes?: AssetTypeJson[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 5;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message entrypoints.v1.ListEntrypointsRequest.
 * Use `create(ListEntrypointsRequestSchema)` to create a new message.
 */
export const ListEntrypointsRequestSchema: GenMessage<ListEntrypointsRequest, { jsonType: ListEntrypointsRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 40);

/**
 * @generated from message entrypoints.v1.ListEntrypointsResponse
 */
export type ListEntrypointsResponse = Message<"entrypoints.v1.ListEntrypointsResponse"> & {
	/**
	 * @generated from field: repeated entrypoints.v1.Entrypoint entrypoints = 1;
	 */
	entrypoints: Entrypoint[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message entrypoints.v1.ListEntrypointsResponse
 */
export type ListEntrypointsResponseJson = {
	/**
	 * @generated from field: repeated entrypoints.v1.Entrypoint entrypoints = 1;
	 */
	entrypoints?: EntrypointJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message entrypoints.v1.ListEntrypointsResponse.
 * Use `create(ListEntrypointsResponseSchema)` to create a new message.
 */
export const ListEntrypointsResponseSchema: GenMessage<ListEntrypointsResponse, { jsonType: ListEntrypointsResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 41);

/**
 * @generated from message entrypoints.v1.BulkDownloadShortUrlsRequest
 */
export type BulkDownloadShortUrlsRequest = Message<"entrypoints.v1.BulkDownloadShortUrlsRequest"> & {
	/**
	 * @generated from field: entrypoints.v1.ListEntrypointsRequest req = 1;
	 */
	req?: ListEntrypointsRequest | undefined;

	/**
	 * @generated from field: repeated string email_recipients = 2;
	 */
	emailRecipients: string[];
};

/**
 * @generated from message entrypoints.v1.BulkDownloadShortUrlsRequest
 */
export type BulkDownloadShortUrlsRequestJson = {
	/**
	 * @generated from field: entrypoints.v1.ListEntrypointsRequest req = 1;
	 */
	req?: ListEntrypointsRequestJson;

	/**
	 * @generated from field: repeated string email_recipients = 2;
	 */
	emailRecipients?: string[];
};

/**
 * Describes the message entrypoints.v1.BulkDownloadShortUrlsRequest.
 * Use `create(BulkDownloadShortUrlsRequestSchema)` to create a new message.
 */
export const BulkDownloadShortUrlsRequestSchema: GenMessage<BulkDownloadShortUrlsRequest, { jsonType: BulkDownloadShortUrlsRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 42);

/**
 * @generated from message entrypoints.v1.BulkDownloadShortUrlsResponse
 */
export type BulkDownloadShortUrlsResponse = Message<"entrypoints.v1.BulkDownloadShortUrlsResponse"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;
};

/**
 * @generated from message entrypoints.v1.BulkDownloadShortUrlsResponse
 */
export type BulkDownloadShortUrlsResponseJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;
};

/**
 * Describes the message entrypoints.v1.BulkDownloadShortUrlsResponse.
 * Use `create(BulkDownloadShortUrlsResponseSchema)` to create a new message.
 */
export const BulkDownloadShortUrlsResponseSchema: GenMessage<BulkDownloadShortUrlsResponse, { jsonType: BulkDownloadShortUrlsResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 43);

/**
 * @generated from message entrypoints.v1.BulkCloneEntrypointsRequest
 */
export type BulkCloneEntrypointsRequest = Message<"entrypoints.v1.BulkCloneEntrypointsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string source_batch_id = 3;
	 */
	sourceBatchId: string;

	/**
	 * @generated from field: string destination_batch_id = 4;
	 */
	destinationBatchId: string;

	/**
	 * @generated from field: repeated string email_recipients = 5;
	 */
	emailRecipients: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 6;
	 */
	pagination?: PaginationArguments | undefined;

	/**
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: Creator | undefined;
};

/**
 * @generated from message entrypoints.v1.BulkCloneEntrypointsRequest
 */
export type BulkCloneEntrypointsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string source_batch_id = 3;
	 */
	sourceBatchId?: string;

	/**
	 * @generated from field: string destination_batch_id = 4;
	 */
	destinationBatchId?: string;

	/**
	 * @generated from field: repeated string email_recipients = 5;
	 */
	emailRecipients?: string[];

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 6;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * @generated from field: common.v1.Creator creator = 7;
	 */
	creator?: CreatorJson;
};

/**
 * Describes the message entrypoints.v1.BulkCloneEntrypointsRequest.
 * Use `create(BulkCloneEntrypointsRequestSchema)` to create a new message.
 */
export const BulkCloneEntrypointsRequestSchema: GenMessage<BulkCloneEntrypointsRequest, { jsonType: BulkCloneEntrypointsRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 44);

/**
 * @generated from message entrypoints.v1.BulkCloneEntrypointsResponse
 */
export type BulkCloneEntrypointsResponse = Message<"entrypoints.v1.BulkCloneEntrypointsResponse"> & {};

/**
 * @generated from message entrypoints.v1.BulkCloneEntrypointsResponse
 */
export type BulkCloneEntrypointsResponseJson = {};

/**
 * Describes the message entrypoints.v1.BulkCloneEntrypointsResponse.
 * Use `create(BulkCloneEntrypointsResponseSchema)` to create a new message.
 */
export const BulkCloneEntrypointsResponseSchema: GenMessage<BulkCloneEntrypointsResponse, { jsonType: BulkCloneEntrypointsResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 45);

/**
 * @generated from message entrypoints.v1.ValidateEntrypointBatchRequest
 */
export type ValidateEntrypointBatchRequest = Message<"entrypoints.v1.ValidateEntrypointBatchRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version: string;
};

/**
 * @generated from message entrypoints.v1.ValidateEntrypointBatchRequest
 */
export type ValidateEntrypointBatchRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string version = 2;
	 */
	version?: string;
};

/**
 * Describes the message entrypoints.v1.ValidateEntrypointBatchRequest.
 * Use `create(ValidateEntrypointBatchRequestSchema)` to create a new message.
 */
export const ValidateEntrypointBatchRequestSchema: GenMessage<ValidateEntrypointBatchRequest, { jsonType: ValidateEntrypointBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 46);

/**
 * @generated from message entrypoints.v1.ValidateEntrypointBatchResponse
 */
export type ValidateEntrypointBatchResponse = Message<"entrypoints.v1.ValidateEntrypointBatchResponse"> & {};

/**
 * @generated from message entrypoints.v1.ValidateEntrypointBatchResponse
 */
export type ValidateEntrypointBatchResponseJson = {};

/**
 * Describes the message entrypoints.v1.ValidateEntrypointBatchResponse.
 * Use `create(ValidateEntrypointBatchResponseSchema)` to create a new message.
 */
export const ValidateEntrypointBatchResponseSchema: GenMessage<ValidateEntrypointBatchResponse, { jsonType: ValidateEntrypointBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_entrypoints_v1_entrypoints, 47);

/**
 * @generated from service entrypoints.v1.EntrypointService
 */
export const EntrypointService: GenService<{
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.GetEntrypoint
	 */
	getEntrypoint: {
		methodKind: "unary";
		input: typeof GetEntrypointRequestSchema;
		output: typeof GetEntrypointResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.GetEntrypointMetadata
	 */
	getEntrypointMetadata: {
		methodKind: "unary";
		input: typeof GetEntrypointMetadataRequestSchema;
		output: typeof GetEntrypointMetadataResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.CountEntrypoints
	 */
	countEntrypoints: {
		methodKind: "unary";
		input: typeof CountEntrypointsRequestSchema;
		output: typeof CountEntrypointsResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.CreateEntrypointBatch
	 */
	createEntrypointBatch: {
		methodKind: "unary";
		input: typeof CreateEntrypointBatchRequestSchema;
		output: typeof CreateEntrypointBatchResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.CreateEntrypointBatchVersion
	 */
	createEntrypointBatchVersion: {
		methodKind: "unary";
		input: typeof CreateEntrypointBatchVersionRequestSchema;
		output: typeof CreateEntrypointBatchVersionResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.PublishEntrypointBatchVersion
	 */
	publishEntrypointBatchVersion: {
		methodKind: "unary";
		input: typeof PublishEntrypointBatchVersionRequestSchema;
		output: typeof PublishEntrypointBatchVersionResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.CreateEntrypointBatchFromTemplate
	 */
	createEntrypointBatchFromTemplate: {
		methodKind: "unary";
		input: typeof CreateEntrypointBatchFromTemplateRequestSchema;
		output: typeof CreateEntrypointBatchFromTemplateResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.ListEntrypointBatches
	 */
	listEntrypointBatches: {
		methodKind: "unary";
		input: typeof ListEntrypointBatchesRequestSchema;
		output: typeof ListEntrypointBatchesResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.GetEntrypointBatch
	 */
	getEntrypointBatch: {
		methodKind: "unary";
		input: typeof GetEntrypointBatchRequestSchema;
		output: typeof GetEntrypointBatchResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.UpdateEntrypointBatch
	 */
	updateEntrypointBatch: {
		methodKind: "unary";
		input: typeof UpdateEntrypointBatchRequestSchema;
		output: typeof UpdateEntrypointBatchResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.DeleteEntrypointBatch
	 */
	deleteEntrypointBatch: {
		methodKind: "unary";
		input: typeof DeleteEntrypointBatchRequestSchema;
		output: typeof DeleteEntrypointBatchResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.BulkDownloadShortUrls
	 */
	bulkDownloadShortUrls: {
		methodKind: "unary";
		input: typeof BulkDownloadShortUrlsRequestSchema;
		output: typeof BulkDownloadShortUrlsResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.BulkCloneEntrypoints
	 */
	bulkCloneEntrypoints: {
		methodKind: "unary";
		input: typeof BulkCloneEntrypointsRequestSchema;
		output: typeof BulkCloneEntrypointsResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.ValidateEntrypointBatch
	 */
	validateEntrypointBatch: {
		methodKind: "unary";
		input: typeof ValidateEntrypointBatchRequestSchema;
		output: typeof ValidateEntrypointBatchResponseSchema;
	};
	/**
	 * Batch templates
	 *
	 * @generated from rpc entrypoints.v1.EntrypointService.CreateEntrypointBatchTemplate
	 */
	createEntrypointBatchTemplate: {
		methodKind: "unary";
		input: typeof CreateEntrypointBatchTemplateRequestSchema;
		output: typeof CreateEntrypointBatchTemplateResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.CreateEntrypointBatchTemplateVersion
	 */
	createEntrypointBatchTemplateVersion: {
		methodKind: "unary";
		input: typeof CreateEntrypointBatchTemplateVersionRequestSchema;
		output: typeof CreateEntrypointBatchTemplateVersionResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.PublishEntrypointBatchTemplateVersion
	 */
	publishEntrypointBatchTemplateVersion: {
		methodKind: "unary";
		input: typeof PublishEntrypointBatchTemplateVersionRequestSchema;
		output: typeof PublishEntrypointBatchTemplateVersionResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.ListEntrypointBatchTemplates
	 */
	listEntrypointBatchTemplates: {
		methodKind: "unary";
		input: typeof ListEntrypointBatchTemplatesRequestSchema;
		output: typeof ListEntrypointBatchTemplatesResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.GetEntrypointBatchTemplate
	 */
	getEntrypointBatchTemplate: {
		methodKind: "unary";
		input: typeof GetEntrypointBatchTemplateRequestSchema;
		output: typeof GetEntrypointBatchTemplateResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.UpdateEntrypointBatchTemplate
	 */
	updateEntrypointBatchTemplate: {
		methodKind: "unary";
		input: typeof UpdateEntrypointBatchTemplateRequestSchema;
		output: typeof UpdateEntrypointBatchTemplateResponseSchema;
	};
	/**
	 * @generated from rpc entrypoints.v1.EntrypointService.DeleteEntrypointBatchTemplate
	 */
	deleteEntrypointBatchTemplate: {
		methodKind: "unary";
		input: typeof DeleteEntrypointBatchTemplateRequestSchema;
		output: typeof DeleteEntrypointBatchTemplateResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_entrypoints_v1_entrypoints, 0);
